export const referrerTypeEnum = [
    {
        stateId: "USER",
        stateName: "个人推荐"
    },
    {
        stateId: "TENANT",
        stateName: "商家推荐"
    },
]
// 处理推荐人类型key转换为label
export const handleReferrerTypeKey2Label = (id) => {
    let res = ""
    res = referrerTypeEnum.find(i => i.stateId === id)
    console.log("res", res)
    return res ? res.stateName : "-"
}
